module.exports = __webpack_public_path__ + "img/抖音操作图示.4ce036cb.png";